<template>
  <AwlModalCard class="px-5 py-4" :border="false">
    <h3 class="text-primary text-center mb-3">Deve essere effettuato il setup per questa azienda</h3>

    <img src="@/assets/images/got-a-balance.png" class="d-block w-50 mx-auto mb-3" />
    <p class="small text-muted">
      E' necessario effettuare il setup del piano previsionale, il procedimento richiede una preparazione preventiva della documentazione contabile. Contatta il tuo referente per Mercurio RFF e chiedi informazioni prima di iniziare il procedimento.
    </p>
    <div class="d-flex justify-content-between">
      <button type="button" class="btn btn-primary" v-if="$oauth2.me.admin || $oauth2.me.consultant" @click.prevent="$emit('input', false)">Non ora</button>
      <button type="button" class="btn btn-primary" @click.prevent="$emit('input', true)">Ok, iniziamo</button>
    </div>
  </AwlModalCard>
</template>

<script>

export default {
  name: 'setup-start',
  components: {
    AwlModalCard: () => import('../../../components/Layout/Card/AwlModalCard'),
  },
};

</script>
